import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATA_SOURCES_METRICS_STATE_NAME, DataSourcesMetricsState} from "./dataSourcesMetrics";
import {Serializers} from '../../interfaces/serializer';
import {DataSourceMetric} from '../../interfaces/metrics';

export const selectDataSourcesMetricsState: MemoizedSelector<object, DataSourcesMetricsState> = createFeatureSelector<DataSourcesMetricsState>(DATA_SOURCES_METRICS_STATE_NAME);

export const selectDataSourcesMetrics: MemoizedSelector<object, Serializers<DataSourceMetric>> = createSelector(
  selectDataSourcesMetricsState,
  (state: DataSourcesMetricsState) => state.serialized
);

export const selectDataSourcesMetricsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesMetricsState,
  (state: DataSourcesMetricsState) => state.loading
);

export const selectDataSourcesMetricsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesMetricsState,
  (state: DataSourcesMetricsState) => state.loaded
);
